import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { ReactElement } from 'react';

import AuthLayout from '../../../../components/layout/AuthLayout/AuthLayout';
import { FindIdPageItem } from '../../../../components/pages/signin/find/id/FindIdPageItem';
import { CaptchaScript } from '../../../../hooks/useCaptcha';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60,
});

function FindIdPage() {
  return <FindIdPageItem />;
}

FindIdPage.getLayout = (page: ReactElement) => (
  <AuthLayout
    meta={{
      title: '메타.아이디찾기.제목',
      description: '메타.아이디찾기.설명',
    }}
  >
    <CaptchaScript />
    {page}
  </AuthLayout>
);

export default FindIdPage;
